import * as React from "react";

function MtLogo(props: any) {
  return (
    <svg
      style={{
        isolation: "isolate",
      }}
      viewBox="-680 -1030 300 180"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M-430-910c5.519 0 10 4.481 10 10s-4.481 10-10 10-10-4.481-10-10 4.481-10 10-10zM-570-910h60c5.519 0 10 4.481 10 10s-4.481 10-10 10h-60c-5.519 0-10-4.481-10-10s4.481-10 10-10zM-590-970c5.519 0 10 4.481 10 10v20c0 5.519-4.481 10-10 10s-10-4.481-10-10v-20c0-5.519 4.481-10 10-10z" />
      <path d="M-639.991-960.515C-639.72-976.836-626.385-990-610-990c7.68 0 14.69 2.892 20 7.645A29.892 29.892 0 01-570-990c16.385 0 29.72 13.164 29.991 29.485.008.17.009.343.009.515v20c0 5.519-4.481 10-10 10s-10-4.481-10-10v-20c0-5.519-4.481-10-10-10s-10 4.481-10 10v20c0 5.519-4.481 10-10 10s-10-4.481-10-10v-20c0-5.519-4.481-10-10-10s-10 4.481-10 10v20c0 5.519-4.481 10-10 10s-10-4.481-10-10v-20c0-.172.004-.344.009-.515zM-460-930v30c0 5.519-4.481 10-10 10s-10-4.481-10-10v-30h-28.82c-6.17 0-11.18-4.481-11.18-10s5.01-10 11.18-10h77.64c6.17 0 11.18 4.481 11.18 10s-5.01 10-11.18 10H-460zM-470-990h40c5.519 0 10 4.481 10 10s-4.481 10-10 10h-40c-5.519 0-10-4.481-10-10s4.481-10 10-10zM-630-910h20c5.519 0 10 4.481 10 10s-4.481 10-10 10h-20c-5.519 0-10-4.481-10-10s4.481-10 10-10zM-515-990h5c5.519 0 10 4.481 10 10s-4.481 10-10 10h-5c-5.519 0-10-4.481-10-10s4.481-10 10-10z" />
      <path d="M-660-910h-20v-70c0-27.596 22.404-50 50-50h200c27.596 0 50 22.404 50 50v80c0 27.596-22.404 50-50 50h-200c-27.596 0-50-22.404-50-50v-20h20v20c0 16.557 13.443 30 30 30h200c16.557 0 30-13.443 30-30v-80c0-16.557-13.443-30-30-30h-200c-16.557 0-30 13.443-30 30v70z" />
    </svg>
  );
}

const MemoMtLogo = React.memo(MtLogo);
export default MemoMtLogo;
